module.exports = __webpack_public_path__ + "static/media/logo.16b5ce3f.png";